import { Component, Input } from '@angular/core';
import { ClaimStatus } from '@cigna/chcp/shared/util';

@Component({
  selector: 'cigna-claim-status',
  templateUrl: './claim-status.component.html',
  styleUrls: ['./claim-status.component.scss'],
})
export class ClaimStatusComponent {
  @Input() status: keyof typeof ClaimStatus;
  @Input() size: 'small' | 'medium' | 'large' = 'small';

  ClaimStatus = ClaimStatus;
}
